import {FC, useState, createContext, useContext, useMemo} from 'react'
import { useMutation } from 'react-query'
import { boolean } from 'yup'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
  ChatListViewContextProps,
  initialChatListView,
} from '../../../../../../_metronic/helpers'
import {useQueryResponse, useQueryResponseData} from './QueryResponseProvider'
import { Chat } from './_models'

const ChatListViewContext = createContext<ChatListViewContextProps>(initialChatListView)

const ChatListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])
  const [statusModal, setStatusModal]  = useState<boolean>(false)
  const [modalAction, setModalAction]  = useState<boolean>(false)
  const [chat, setChat]  = useState<Chat>({})


  return (
    <ChatListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          
         groupingOnSelectAll(isAllSelected, setSelected, data)
         console.log(selected + "SELECTED ISSUES");
        },
        clearSelected: () => {
          setSelected([])
        },
        statusModal,
        setStatusModal: (value,action) => {
          setStatusModal(value);
          setModalAction(action);
        },
        modalAction,
        setChat,
        chat
      }}
    >
      {children}
    </ChatListViewContext.Provider>
  )


  
}

const useListView = () => useContext(ChatListViewContext)

export {ChatListViewProvider, useListView}
